import { render } from "./ProductListPage.vue?vue&type=template&id=2e3fe0fa&scoped=true"
import script from "./ProductListPage.vue?vue&type=script&lang=js"
export * from "./ProductListPage.vue?vue&type=script&lang=js"

import "./ProductListPage.vue?vue&type=style&index=0&id=2e3fe0fa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e3fe0fa"]])

export default __exports__